import React from 'react';

import {getConditions} from '../../services/Api';
import {showErrors} from '../../services/errorsMessages';
import {ErrorWarning} from '../../shared/components/ErrorWarning';
import {useChatStore} from '../../store/slices/chatStore';
import {useTermsStore} from '../../store/slices/termsStore';
import {startScrollingChat} from '../../utils';

export const TermsConditionsReplay = () => {
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setMessages = useChatStore((state) => state.setMessages);
  const commercialConditionsReceived = useTermsStore(
    (state) => state.commercialConditionsReceived
  );

  const getTermsConditionsRequest = () => {
    getConditions()
      .then((response) => {
        if (response.data) {
          commercialConditionsReceived(response.data);
          responseTypeChange('disabled');
          startScrollingChat(0);
        }
      })
      .catch((error) => {
        const showResponse = showErrors(error, 'termos e condições');
        setMessages(showResponse.messages);
      });
  };

  return (
    <div className="warning-content">
      <ErrorWarning
        htmlId="repeat-request-banks-account-types"
        request={getTermsConditionsRequest}
      />
    </div>
  );
};
